export default "__VITE_ASSET__C56ETI9O__"